import React, {useContext, useEffect, useState} from 'react';
import {Button, Card, Col, ListGroup, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {
    FaBook,
    FaBookOpen,
    FaCheckCircle,
    FaCoins,
    FaStar,
    FaUser
} from "react-icons/fa";
import InfoAssUnderBookS4 from "../modals/book/InfoAssUnderBookS4";
import {FaCheck, FaCircleXmark, FaTrashCan} from "react-icons/fa6";

const AssignUnderBookS4 = ({ assign, updateAssignments, isLinked }) => {
    const  [infoS4Visible, setinfoS4Visible] = useState(false);
    const  [rateReviewQualityVisible, setRateReviewQualityVisible] = useState(false);
    const  [giveMeBackVirtVisible, setGiveMeBackVirtVisible] = useState(false);
    const [localAssign, setLocalAssign] = useState(assign);
    const isMobile = window.innerWidth <= 768; // Проверяем, является ли устройство мобильным

    useEffect(() => {
        setLocalAssign(assign); // обновляем, если проп сменился
    }, [assign]);

    const navigate = useNavigate();


    const date = new Date(assign.end_rev_date * 60 * 1000);

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();



    // Форматируем вывод (часы и минуты с ведущим нулем, если нужно)
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;

        return (

        <>
            <Card
                className="mt-0 p-0 mx-auto mb-1"
                style={{
                    borderRadius: '6px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: isLinked === false ? 'not-allowed' : 'pointer',
                    //height: '138px', // ✅ Фиксированная высота карточки
                }}

                onClick={isLinked !== false ? () => setinfoS4Visible(true) : undefined}

                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0px 4px 12px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >


                    <Card.Body className="d-flex flex-column position-relative py-2 px-3">
                        {assign.assignment_status === 'SUCCESS' ? (
                            <>
                                <p
                                    className=" fw-semibold mb-1 mt-0 text-muted"
                                    style={{
                                        display: "block", // ✅ Заменяем `-webkit-box` на `block` для лучшего контроля
                                        maxWidth: "100%", // ✅ Заполняет всю ширину родителя
                                        overflow: "hidden",
                                        textOverflow: "ellipsis", // ✅ Обрезает в конце, а не заранее
                                        whiteSpace: "nowrap" // ✅ Чтобы работало корректно для одной строки
                                    }}
                                >
                                    <FaCheckCircle className="me-1 text-success" />

                                    {/* ✅ Анимированная иконка */}
                                    Assignment has been Confirmed!
                                </p>
                                <Row className="gap-1">

                                    <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        lineHeight: "1.2",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>
                                        <FaBookOpen className="me-2" />
                                        Confirmed: <b>{`${month}-${day}`}</b> at: <b>{`${formattedHours}:${formattedMinutes}`}</b>

                                    </p>


                                    <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        lineHeight: "1.2",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>
                                        <FaBook className="me-1" /> {/* ✅ Улучшенная иконка */}
                                        Type:{" "}<b>
                                        {(() => {
                                            switch (assign.assTypeId) {
                                                case 1: return "Universal Assignment";
                                                case 2: return "Kindle Unlimited";
                                                case 3: return "Kindle Verified Purchase";
                                                case 4: return "Kindle Verified Purchase + Img";
                                                case 5: return "Kindle Verified Purchase Search&Buy";
                                                case 6: return "Kindle Verified Search&Buy + Img";
                                                case 7: return "Universal Assignment for Audio";
                                                case 8: return "Audible Promo Code Assignment";
                                                case 9: return "Verified Kindle Unlimited";
                                                case 10: return "Paperback BuyOut";
                                                case 11: return "Paperback Search&BuyOut";
                                                case 12: return "Paperback Verified Purchase + Img";
                                                case 13: return "Paperback Verified Purchase + Video";
                                                case 14: return "HC BuyOut";
                                                case 15: return "HC Search&BuyOut";
                                                case 16: return "HC Verified Pur. + Img";
                                                case 17: return "HC Verified + Video";
                                                case 18: return "PB Verified Purchase";
                                                case 19: return "PB Verified Purchase Search&Buy";
                                                case 20: return "HC Verified Purchase";
                                                case 21: return "HC Verified Purchase Search&Buy";
                                                case 22: return "Product BuyOut";
                                                case 23: return "Prod. Search&BuyOut";
                                                case 24: return "Prod. Verified Pur.";
                                                case 25: return "Prod. Verified + Img";
                                                case 26: return "Prod. Verified + Vid";
                                                case 27: return "Prod. VP Search&Buy";
                                                case 28: return "Make Helpful Internal";
                                                case 29: return "Write Report Internal";
                                                case 30: return "Make Helpful External";
                                                case 31: return "Write Report External";
                                                case 32: return "Set Stars Rating";
                                                default:
                                                    return "Unknown Type"; // ✅ Защита от неверных значений
                                            }
                                        })()}</b>
                                    </p>
                                    <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        lineHeight: "1.2",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>
                                        <FaCoins className="me-2" />
                                        Cost: <b>{localAssign?.assignment_price_publisher === 0 ? 'Refunded, ' : `${localAssign?.assignment_price_publisher} Virt /`}</b>
                                        <b className="text-danger">
                                        {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(localAssign?.assTypeId) ? (
                                            localAssign?.assignment_price_publisher
                                                ? ` $${localAssign.book_cost_compensation}`
                                                : "N/A"
                                        ) : (
                                            (() => {
                                                let priceLabel;
                                                switch (localAssign?.booksPriceId) {
                                                    case 1: priceLabel = " Free"; break;
                                                    case 2: priceLabel = " $0.99"; break;
                                                    case 3: priceLabel = " $1.99"; break;
                                                    case 4: priceLabel = " $2.99"; break;
                                                    case 5: priceLabel = " $3.99"; break;
                                                    case 6: priceLabel = " $4.99"; break;
                                                    case 7: priceLabel = " $5.99"; break;
                                                    case 8: priceLabel = " $6.99"; break;
                                                    case 9: priceLabel = " $7.99"; break;
                                                    case 10: priceLabel = " $8.99"; break;
                                                    case 11: priceLabel = " $9.99"; break;
                                                    default: priceLabel = " Unknown Type";
                                                }

                                                // Добавляем " Promo" при нужных условиях
                                                if (localAssign?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(localAssign?.assTypeId)) {
                                                    priceLabel += " Promo";
                                                }

                                                return priceLabel;
                                            })()
                                        )}
                                        </b>
                                    </p>
                                    <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        lineHeight: "1.2",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>
                                        <FaUser className="me-2" />
                                        Participant: <b>
                                        {(assign.reviewer_name || 'No').length > 30
                                            ? `${assign.reviewer_name.slice(0, 30)}...`
                                            : assign.reviewer_name || 'Unknown'} /
                                    </b>
                                        <b>
                                            {(() => {
                                                switch (assign.assignment_prefer_country) {
                                                    case "https://www.amazon.com":
                                                        return " US";
                                                    case "https://www.amazon.ca":
                                                        return " CA";
                                                    case "https://www.amazon.com.au":
                                                        return " AU";
                                                    case "https://www.amazon.co.uk":
                                                        return " UK";
                                                    case "https://www.amazon.de":
                                                        return " DE";
                                                    case "https://www.amazon.fr":
                                                        return " FR";
                                                    case "https://www.amazon.it":
                                                        return " IT";
                                                    case "https://www.amazon.es":
                                                        return " ES";
                                                    case "https://www.amazon.in":
                                                        return " IN";
                                                    case "https://www.amazon.co.jp":
                                                        return " JP";
                                                    case "https://www.amazon.com.br":
                                                        return " BR";
                                                    case "https://www.amazon.nl":
                                                        return " NL";
                                                    case "https://www.amazon.com.mx":
                                                        return " MX";
                                                    case "https://www.amazon.sg":
                                                        return " SG";
                                                    case "https://www.amazon.cn":
                                                        return " CH";
                                                    default:
                                                        return " All";
                                                }
                                            })()}</b> {assign?.rating_of_reviewer > 20 && (
                                        <span className="ms-0 fw-semibold text-success">
                                        / Q-{assign.rating_of_reviewer}%
                                     </span>
                                    )}


                                    </p>
                                    <p
                                        className="me-2 mb-1 mt-0 small text-muted d-flex justify-content-between align-items-center"
                                        style={{
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                            lineHeight: "1.2",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                         <span>
                                              <FaStar className="me-2" />
                                                      Rating:  <b>
                                                    {assign.rating
                                                        ? `${assign.rating}.0 `
                                                        : 'Not Applicable '}
                                                </b>{" "} {assign.rating && (<>{" "}
                                                   {[...Array(5)].map((_, index) => (
                                                  <i
                                                     key={index}
                                                     className={`bi bi-star${index < assign.rating ? "-fill" : ""}`}
                                                     style={{
                                                         color: index < assign.rating ? "gold" : "lightgray",
                                                         fontSize: "12px",
                                                         marginRight: "3px"
                                                      }}
                                                    ></i>
                                                 ))}
                                        </>)}
                                             </span>

                                        <span className="ms-2 d-flex align-items-center">
                                         {assign?.check_status === "COMPLETE" && (
                                              <>
                                                   <FaCheck
                                                       size={12}
                                                       aria-hidden="true"
                                                       focusable="false"
                                                   />
                                            <span className="ms-1">Complete</span>
                                              </>
                                               )}
                                            {assign?.check_status === "COMPLAINT" && (
                                                <>
                                                    <i style={{ animationDuration: "1.4s" }}
                                                       className="bi bi-hourglass-split animate__animated animate__rotateIn animate__infinite text-danger me-1"
                                                       aria-hidden="true"
                                                    ></i>
                                                    <span className="">Complaint</span>
                                                </>
                                            )}
                                            {assign?.check_status === "REFUNDED" && (
                                                <>
                                                    <i className="bi bi-check-circle-fill me-1"></i>
                                                    <span className="">Refunded</span>
                                                </>
                                            )}
                                            {assign?.check_status === "DECLINED" && (
                                                <>
                                                    <i className="bi bi-x-circle-fill me-1"></i>
                                                    <span className="">Declined</span>
                                                </>
                                            )}
  </span>
                                    </p>


                                </Row>



                            </>
                        ) :  ('')}

                </Card.Body>
            </Card>
            <InfoAssUnderBookS4
                show={infoS4Visible}
                handleClose={() => setinfoS4Visible(false)}
                assignment={assign}
                onClosed={updateAssignments}
            />

        </>


    );
};

export default AssignUnderBookS4;
